"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.staticRenderFns = exports.render = void 0;
var render = exports.render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c("div", {
    staticClass: "login-container"
  }, [_c("el-form", {
    ref: "recoveryForm",
    staticClass: "login-form",
    attrs: {
      model: _vm.recoveryForm,
      rules: _vm.recoveryRules,
      autocomplete: "on",
      "label-position": "left"
    }
  }, [_c("div", {
    staticClass: "title-container"
  }, [_c("img", {
    staticClass: "login-logo",
    attrs: {
      src: require("@/assets/img/logo.png")
    }
  }), _c("h1", {
    staticClass: "title"
  }, [_vm._v(" " + _vm._s(_vm.$t("login.recoverTitle")) + " ")])]), _c("el-form-item", {
    attrs: {
      prop: "email"
    }
  }, [_c("span", {
    staticClass: "svg-container"
  }, [_c("svg-icon", {
    attrs: {
      name: "user"
    }
  })], 1), _c("el-input", {
    ref: "email",
    attrs: {
      placeholder: _vm.$t("login.email"),
      name: "email",
      type: "text",
      autocomplete: "on"
    },
    model: {
      value: _vm.recoveryForm.email,
      callback: function ($$v) {
        _vm.$set(_vm.recoveryForm, "email", $$v);
      },
      expression: "recoveryForm.email"
    }
  })], 1), _c("el-button", {
    staticStyle: {
      width: "40%",
      "margin-left": "150px",
      "margin-bottom": "30px"
    },
    attrs: {
      loading: _vm.loading,
      type: "success"
    },
    nativeOn: {
      click: function ($event) {
        $event.preventDefault();
        return _vm.handleLogin.apply(null, arguments);
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("login.recover")) + " ")])], 1)], 1);
};
var staticRenderFns = exports.staticRenderFns = [];
render._withStripped = true;